import React from 'react'
import { FaBars } from 'react-icons/fa';
import  LogoSrc  from '../../images/20220498.svg';
import { Nav, NavbarContainer, NavLogo, 
    MoblieIcon, NavMenu, NavItem, NavLinks,Logo } from './NavbarElements';
import { animateScroll as scroll } from 'react-scroll/modules';
const Navbar = ({ toggle }) => {
  const toggleHome = () => {
      scroll.scrollToTop();
  }
  return (
    <>
    <Nav>
        <NavbarContainer>
            <NavLogo to="/" onClick={toggleHome} aria-label="El Jimmy">
               <Logo loading="lazy" src={LogoSrc} alt="Jaime Ivan Ramirez Osorio @jimmyramz" title="Jaime Ivan Ramirez Osorio @jimmyramz" width="100%" height="100%" />
            </NavLogo>
            <MoblieIcon onClick={toggle}>
                <FaBars />
            </MoblieIcon>
            <NavMenu>
                <NavItem>
                    <NavLinks to="/" onClick={toggleHome}>
                        Inicio
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="Acerca_Jimmy" smooth={true} duration={500} spy={true} exact='true' offset={80}>
                        Acerca del Jimmy
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="Habilities" smooth={true} duration={500} spy={true} exact='true' offset={80}>
                        Habilidades
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to="Portafolio" smooth={true} duration={500} spy={true} exact='true' offset={80}>
                        Portafolio
                    </NavLinks>
                </NavItem>
                

            </NavMenu>
          
        </NavbarContainer>
    </Nav>
</>
  )
}

export default Navbar